import { render, staticRenderFns } from "./edit-emails.vue?vue&type=template&id=5dfed7fe&scoped=true&"
import script from "./edit-emails.vue?vue&type=script&lang=js&"
export * from "./edit-emails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dfed7fe",
  null
  
)

export default component.exports